var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-loading-indicator",class:{'map-loading-indicator-visible': _vm.loadingData, expanded: _vm.rightExpanded, wide: _vm.rightWide}},[_c('FaIcon',{attrs:{"icon":_vm.icon,"size":"3x","spin":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }